import { render } from "./AddressExchangeReadModal.vue?vue&type=template&id=48e4718b&scoped=true"
import script from "./AddressExchangeReadModal.vue?vue&type=script&lang=js"
export * from "./AddressExchangeReadModal.vue?vue&type=script&lang=js"

import "./AddressExchangeReadModal.vue?vue&type=style&index=0&id=48e4718b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e4718b"]])

export default __exports__